import React from 'react';
import { splitPromptTextForHighlight } from '../../utils/seedancePromptUtils';

function isPromptMediaRefToken(part: string, namedMentions: Set<string>): boolean {
  if (!part) return false;
  if (/^@(?:图|视频|音频)\d+$/.test(part)) return true;
  if (part.startsWith('@') && namedMentions.has(part.slice(1))) return true;
  if (/^视频\d+$/.test(part)) return true;
  if (/^音频\d+$/.test(part)) return true;
  if (/^(?<!片)图\d+$/.test(part)) return true;
  return false;
}

/** 工作台 / 重新生成弹窗共用：将 @图N/@视频N/@音频N 与提交形态的 图N/视频N/音频N 渲染为胶囊高亮。 */
export const PromptTextHighlight: React.FC<{
  text: string;
  namedMentions?: string[];
}> = ({ text, namedMentions = [] }) => {
  const normalizedNamedMentions = new Set(
    namedMentions.map((name) => name.trim().replace(/^@+/, '')).filter(Boolean),
  );
  const parts = splitPromptTextForHighlight(text, namedMentions);
  return (
    <>
      {parts.map((part, idx) =>
        isPromptMediaRefToken(part, normalizedNamedMentions) ? (
          <span className="prompt-mention-inline" key={`${part}-${idx}`}>
            {part}
          </span>
        ) : (
          <span className="prompt-highlight-plain" key={`${idx}-${part.slice(0, 12)}`}>
            {part}
          </span>
        ),
      )}
      {/* 末尾零宽空格：文本以 \n 结尾时 div 不渲染最后的空行而 textarea 会，
          导致两层 scrollHeight 差一行、滚动同步被钳制错位 */}
      {'\u200b'}
    </>
  );
};

export default PromptTextHighlight;
